export default __webpack_public_path__ + "static/media/patria-breathing.a46f5930.png";